import {
  PlatformDocumentFragment,
  PlatformDocumentDisplayOn as ApiPlatformDocumentDisplayOn,
} from "@/graphql";
import { PlatformDocument, PlatformDocumentDisplayOn } from "@/types";

export const mapToPlatformDocument = (
  platformDocument: PlatformDocumentFragment
): PlatformDocument => {
  return {
    id: platformDocument.id,
    name: platformDocument.name,
    legacyDocumentUrl: platformDocument.legacyDocumentUrl ?? null,
    documentFile: platformDocument.documentFile ?? null,
    displayOn: platformDocument.displayOn.map(mapToPlatformDocumentDisplayOn),
    sortingPositions: Object.fromEntries(
      platformDocument.sortingPositions.map((position) => [
        mapToPlatformDocumentDisplayOn(position.displayOn),
        position.position,
      ])
    ) as { [key in PlatformDocumentDisplayOn]?: number },
  };
};

const platformDocumentDisplayOnMap: {
  [key in ApiPlatformDocumentDisplayOn]: PlatformDocumentDisplayOn;
} = {
  [ApiPlatformDocumentDisplayOn.LeaguePage]: "leaguePage",
  [ApiPlatformDocumentDisplayOn.Rankings]: "rankings",
  [ApiPlatformDocumentDisplayOn.TournamentsCalendar]: "tournamentsCalendar",
};

export const mapToPlatformDocumentDisplayOn = (
  displayOn: ApiPlatformDocumentDisplayOn
): PlatformDocumentDisplayOn => {
  return platformDocumentDisplayOnMap[displayOn];
};

const platformDocumentDisplayOnMapReverse: {
  [key in PlatformDocumentDisplayOn]: ApiPlatformDocumentDisplayOn;
} = {
  leaguePage: ApiPlatformDocumentDisplayOn.LeaguePage,
  rankings: ApiPlatformDocumentDisplayOn.Rankings,
  tournamentsCalendar: ApiPlatformDocumentDisplayOn.TournamentsCalendar,
};

export const mapToApiPlatformDocumentDisplayOn = (
  displayOn: PlatformDocumentDisplayOn
): ApiPlatformDocumentDisplayOn => {
  return platformDocumentDisplayOnMapReverse[displayOn];
};
